import { Button } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import { assignFlag } from "../../../../services/flag";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateRow } from "../../../../redux/features/monitoringQueue/monitoringQueueSlice";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";

const UnlockButton = ({ flagId }) => {
  const dispatch = useDispatch();
  const unlockRolePermission = useCheckPermission("UNLOCK");

  const mutateUnlock = useMutation({
    mutationKey: ["unlock-flag-mq"],
    mutationFn: (flagId) =>
      assignFlag({
        flagId,
        assign: false,
      }),
    onSuccess: ({ data }) => {
      dispatch(updateRow(data));
      toast.success("Flag successfully unlocked");
    },
    onError: (err) => {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to unlock flag");
    },
  });

  if (!unlockRolePermission) return null;

  return (
    <Button
      loading={mutateUnlock.isPending}
      onClick={() => mutateUnlock.mutate(flagId)}
      size="xs"
      variant="outline"
    >
      Unlock
    </Button>
  );
};

export default UnlockButton;
